var _excluded = ["label", "disabled", "icon", "intent", "onClick", "mode"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import IconButton from '../iconButton';
var buttonStyle = function buttonStyle(_ref) {
  var disabled = _ref.disabled,
    intent = _ref.intent,
    theme = _ref.theme;
  return {
    padding: 0,
    border: 0,
    font: 'inherit',
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 1,
    ':focus': {
      outline: 0,
      boxShadow: '0 0 0 1px white, 0px 0px 0 3px ' + theme.tokens.focusColor,
      ':not(:focus-visible)': {
        boxShadow: 'none'
      }
    },
    extend: [{
      condition: !disabled,
      style: {
        ':active': {
          transform: 'scale(0.90)'
        }
      }
    }, {
      condition: intent === 'primary' && !disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonPrimaryBackground,
        borderColor: theme.tokens.actionButtonPrimaryBorder,
        ':active': {
          backgroundColor: theme.tokens.actionButtonPrimaryActiveBackground,
          borderColor: theme.tokens.actionButtonPrimaryActiveBorder
        },
        ':hover': {
          backgroundColor: theme.tokens.actionButtonPrimaryHoverBackground,
          borderColor: theme.tokens.actionButtonPrimaryHoverBorder
        }
      }
    }, {
      condition: intent === 'primary' && disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonPrimaryDisabledBackground,
        borderColor: theme.tokens.actionButtonPrimaryDisabledBorder
      }
    }, {
      condition: intent === 'primary-alternate' && !disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonPrimaryAlternateBackground,
        borderColor: theme.tokens.actionButtonPrimaryAlternateBorder,
        ':active': {
          backgroundColor: theme.tokens.actionButtonPrimaryAlternateActiveBackground,
          borderColor: theme.tokens.actionButtonPrimaryAlternateActiveBorder
        },
        ':hover': {
          backgroundColor: theme.tokens.actionButtonPrimaryAlternateHoverBackground,
          borderColor: theme.tokens.actionButtonPrimaryAlternateHoverBorder
        }
      }
    }, {
      condition: intent === 'primary-alternate' && disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonPrimaryAlternateDisabledBackground,
        borderColor: theme.tokens.actionButtonPrimaryAlternateDisabledBorder
      }
    }, {
      condition: intent === 'control' && !disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonControlBackground,
        borderColor: theme.tokens.actionButtonControlBorder,
        ':active': {
          backgroundColor: theme.tokens.actionButtonControlActiveBackground,
          borderColor: theme.tokens.actionButtonControlActiveBorder
        },
        ':hover': {
          backgroundColor: theme.tokens.actionButtonControlHoverBackground,
          borderColor: theme.tokens.actionButtonControlHoverBorder
        }
      }
    }, {
      condition: intent === 'control' && disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonControlDisabledBackground,
        borderColor: theme.tokens.actionButtonControlDisabledBorder
      }
    }, {
      condition: intent === 'function' && !disabled,
      style: {
        borderColor: theme.tokens.actionButtonFunctionBorder,
        backgroundColor: theme.tokens.actionButtonFunctionBackground,
        ':active': {
          backgroundColor: theme.tokens.actionButtonFunctionActiveBackground,
          borderColor: theme.tokens.actionButtonFunctionActiveBorder
        },
        ':hover': {
          backgroundColor: theme.tokens.actionButtonFunctionHoverBackground,
          borderColor: theme.tokens.actionButtonFunctionHoverBorder
        }
      }
    }, {
      condition: intent === 'function' && disabled,
      style: {
        backgroundColor: theme.tokens.actionButtonFunctionDisabledBackground,
        borderColor: theme.tokens.actionButtonFunctionDisabledBorder
      }
    }]
  };
};
var iconColor = function iconColor(_ref2) {
  var disabled = _ref2.disabled,
    intent = _ref2.intent,
    theme = _ref2.theme;
  if (disabled) {
    return theme.tokens.actionButtonDisabledForeground;
  }
  switch (intent) {
    case 'primary':
      return theme.tokens.actionButtonPrimaryForeground;
    case 'primary-alternate':
      return theme.tokens.actionButtonPrimaryAlternateForeground;
    case 'control':
      return theme.tokens.actionButtonControlForeground;
    case 'function':
      return theme.tokens.actionButtonFunctionForeground;
    default:
      break;
  }
};
var FloatingActionButton = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var label = _ref3.label,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    icon = _ref3.icon,
    _ref3$intent = _ref3.intent,
    intent = _ref3$intent === void 0 ? 'primary' : _ref3$intent,
    onClick = _ref3.onClick,
    mode = _ref3.mode,
    props = _objectWithoutProperties(_ref3, _excluded);
  var _useFela = useFela(),
    theme = _useFela.theme;
  var style = buttonStyle({
    intent: intent,
    disabled: disabled,
    theme: theme
  });
  var color = iconColor({
    disabled: disabled,
    intent: intent,
    theme: theme
  });
  var size = mode === 'compact' ? [24,,, 20] : [48,,, 40];
  var iconSize = mode === 'compact' ? 12 : 16;
  return /*#__PURE__*/React.createElement(IconButton, _extends({}, props, {
    ref: ref,
    size: size,
    icon: icon,
    iconSize: iconSize,
    onClick: onClick,
    disabled: disabled,
    color: color,
    label: label,
    extend: style
  }));
});
export default FloatingActionButton;
FloatingActionButton.displayName = 'FloatingActionButton';
FloatingActionButton.propTypes = {
  intent: PropTypes.oneOf(['primary', 'primary-alternate', 'control', 'function']),
  mode: PropTypes.oneOf(['normal', 'compact']),
  disabled: PropTypes.bool,
  /** A description of what the action does for screen readers */
  label: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};